const wallOfLegends = [
	{
		path: '/agency/wall-of-legends/list',
		name: 'agency-wall-of-legends-list',
		component: () => import('@/views/agency/wall-of-legends/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,wall-of-legends',
		},
	},
]

export default wallOfLegends
